import { render } from "./Danger.vue?vue&type=template&id=7bdfb52e"
import script from "./Danger.vue?vue&type=script&lang=js"
export * from "./Danger.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__